import {
	formProcessor,
	validationProcessor,
	analyticsProcessor
} from "./onLoad";
import { onChangeAction, onCompleteAction } from "./services";
import { indicateDependentFields, setValueFieldStatus } from "./dependencies";
import { FIELDTYPES, STATES, fieldActionConstants } from "../common/constants";
import { getFromLocalStorage } from "./utility";
import { ClickStreamEventActions } from "../native/constants";
import { getApiValueKeys, objectMapping } from "./helper";

const EntityListenerType = {
	EVENT: "event",
	VALIDATE: "validate",
	OTHER: "other",
	BLUR: "blur",
	CHANGE: "change",
	CLICK: "click",
	COMPLETE: "complete",
	MODAL: "MODAL"
};

const getFiltered = (entity) => {
	if (entity?.filter && entity.filter.enable) {
		const filterOn = entity.options;
		entity.filter.options = filterOn.filter((item) =>
			item.value.includes(entity.filter.value)
		);
	}
	return entity.filter;
};

const updateAppendFieldValue = (appended) => {
	const updateValuefield = formProcessor.getField(appended.fieldId.appendById);
	if (updateValuefield) {
		const currentValue = updateValuefield.fieldValue || {};
		currentValue[appended.fieldId.id] = appended.addOn.value;
		formProcessor.updateField({
			fieldId: appended.fieldId.appendById,
			fieldValue: currentValue
		},
			{ actionType: fieldActionConstants.UPDATE_VALUE });
	}
};

const dependentFieldAction = (fieldData) => {
	if (fieldData) indicateDependentFields(fieldData)
}

const fieldStateCompleteObject = (fieldData, type) => {
	const data = formProcessor.getValueFieldMap(fieldData?.id);
	let defaultValue = getApiValueKeys(fieldData?.attributes?.defaultValue) || "";
	const selectedPlan = {};
	if (fieldData?.attributes?.defaultValue && fieldData?.attributes?.defaultValue.includes("selectedPlan")) {
		selectedPlan.serviceId = defaultValue
	}
	if (
		fieldData?.attributes &&
		fieldData.attributes?.defaultValue &&
		fieldData.attributes?.defaultValue.includes("localstorage") &&
		fieldData.attributes?.defaultValue.split("-").length
	) {
		const moduleName = fieldData.attributes?.defaultValue
			.split("-")[1]
			.split(".")[0];
		const keyName = fieldData.attributes?.defaultValue
			.split("-")[1]
			.split(".")[1];

		const localstorageData = getFromLocalStorage(moduleName, keyName);
		if (
			localstorageData &&
			localstorageData[
			fieldData.attributes?.defaultValue.split("-")[1].split(".")[2]
			]
		) {
			defaultValue =
				localstorageData[
				fieldData.attributes?.defaultValue.split("-")[1].split(".")[2]
				];
		}
	}
	let checked, value;
	if (fieldData.fieldType === FIELDTYPES.CHECKBOX) {
		if (defaultValue === 'checked') {
			checked = true;
			value = 'checked';
		} else {
			checked = false;
			value = 'unchecked';
		}
	} else {
		value = defaultValue || data?.fieldValue || "";
		checked = data?.checked || false
	}
	const fieldStateObject = {
		id: fieldData?.id,
		value,
		type: type,
		checked,
		attributes: data?.attributes || fieldData?.attributes || {},
		options: data?.fieldOptions || fieldData?.sourceInfo?.options || [],
		errorInfo: data?.errorInfo || {
			text: "",
			state: STATES.NONE,
		},
		filter: {
			enable: false,
			options: [],
			value: "",
			checked: false,
			selectedValue: ""
		},
	};
	if (selectedPlan?.serviceId) {
		fieldStateObject.value = selectedPlan;
	}

	return fieldStateObject;
};

const onActionEntity = (entity) => {
	return {
		updatedValue: entity.updatedValue,
		priorityVal: entity?.priorityVal || "",
		checked: entity.checked || false,
		fieldData: entity.fieldData,
		listenerType: entity.listenerType || EntityListenerType.EVENT,
		actionType: entity.actionType,
		validate: entity.validate || false,
		metric: objectMapping({}, entity.metric) || {},
		appendedId: entity?.appendById,
		saveToFilter: entity?.saveToFilter
	};
};

function attributeListener(entity) {
	this.setFieldState({
		...this.fieldState,
		attributes: entity.attributes || {},
		value: entity?.value || this.fieldState.value,
		checked: entity?.checked,
		options: entity?.options || this.fieldState?.options
	});
}

function filterListener(entity) {
	this.setFieldState({ ...this.fieldState, filter: getFiltered(entity) });
}

function errorListener(entity) {
	const status = formProcessor.getValueFieldStatus(entity?.fieldId);
	if (!status) {
		this.setFieldState({
			...this.fieldState,
			value: entity.value,
			errorInfo: entity.errorInfo
		});
	}
}

async function changeListener(entity) {
	formProcessor.updateField({
		fieldId: entity.fieldData.id,
		fieldValue: entity.updatedValue,
		checked: entity.checked,
		metric: entity?.metric,
		saveToFilter: entity?.saveToFilter
	}, { actionType: entity.actionType });
}

async function blurListener(entity) {
	const errorInfo = validationProcessor.validateField({
		fieldId: entity.fieldData.id,
		fieldValue: entity?.priorityVal || entity.updatedValue,
		fieldData: entity?.fieldData,
		type: entity?.fieldData?.validation?.validationType || "default"
	});
	entity.errorInfo = objectMapping({}, errorInfo);
	if (errorInfo.type) {
		if (entity?.metric?.fireAnalytics) {
			sendAnalytics(entity?.fieldData, entity);
		}
		!entity?.fieldData?.attributes?.disabled && onCompleteAction(
			entity?.fieldData,
			entity?.fieldData?.actionsMapping,
			entity
		);
	}
	formProcessor.updateField({
		fieldId: entity.fieldData.id,
		fieldValue: entity.updatedValue,
		metric: entity?.metric,
		errorInfo: entity?.errorInfo
	}, { actionType: entity.actionType });
	setValueFieldStatus(entity?.fieldData.id, entity);
	dependentFieldAction(entity?.fieldData);
}

async function entityListener(entity) {
	(fieldStateUpdate.bind(this))(entity);
	(onFieldCompleteAction.bind(this))(entity);
}

function onFieldCompleteAction(entity) {
	if (this.fieldData?.appendById)
		updateAppendFieldValue({ fieldId: this.fieldData, addOn: entity });
	if (this.fieldState?.id) {
		entity = objectMapping({ type: this.type }, entity)
		setValueFieldStatus(this.fieldState.id, entity);
	}
	if (entity?.metric?.fireAnalytics) {
		sendAnalytics(this.fieldData, entity);
	}
	if (this.fieldData) {
		dependentFieldAction(this.fieldData);
		onChangeAction(this.fieldData, this.fieldData?.actionsMapping, entity);
	}

}

function fieldStateUpdate(entity) {
	this.setFieldState({
		...this.fieldState,
		value: entity.value,
		options: entity.options,
		checked: entity.checked,
		errorInfo: entity.errorInfo
	});
}

function sendAnalytics(fieldData, entity) {
	analyticsProcessor.captureAnalytics({
		analyticsId: `${fieldData.id || fieldData.sectionId}_analytics`,
		fieldData: fieldData,
		fieldId: fieldData.id,
		sectionId: fieldData.sectionId,
		metric: {
			action: ClickStreamEventActions.click,
			subSection: fieldData?.attributes?.analytics?.subSection || "",
			eventLabel: entity?.metric?.eventLabel || fieldData?.attributes?.analytics?.eventLabel,
			eventValue: entity?.metric?.eventValue || "",
			prop26: entity?.metric?.prop26 || "",
			prop4: entity?.metric?.prop4 || "",
			eVar32: entity?.metric?.eVar32 || ""
		}
	})
}

export {
	EntityListenerType,
	fieldStateCompleteObject,
	onActionEntity,
	attributeListener,
	filterListener,
	entityListener,
	errorListener,
	changeListener,
	blurListener,
	dependentFieldAction,
	sendAnalytics
};
